<script lang='ts'>
  export let show_intro:boolean

  function hide_intro() {
    show_intro = false
    localStorage.setItem('is_subsequent_visit','true')
  }
</script>
<style>
  ul {
    text-align: start;
  }
</style>
<div class='win'>
  <h2>Welcome to Wikiguessr!</h2>
  <p>The object of the game is to guess the title of a Wikipedia article, based on the the words that appear the most frequently in it.</p>
  <ul>
    <li>Common filler words are removed.</li>
    <li>You must reveal at least one word before each guess.</li>
    <li>A new puzzle is released every day!</li>
  </ul>
  <button on:click={hide_intro}>Close this message</button>
</div>